import { render, staticRenderFns } from "./WordpressApiKey.vue?vue&type=template&id=5e16fa26&scoped=true&"
import script from "./WordpressApiKey.vue?vue&type=script&lang=js&"
export * from "./WordpressApiKey.vue?vue&type=script&lang=js&"
import style0 from "./WordpressApiKey.vue?vue&type=style&index=0&id=5e16fa26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e16fa26",
  null
  
)

export default component.exports